import { render } from "./Throughput.vue?vue&type=template&id=64fe73e4"
import script from "./Throughput.vue?vue&type=script&lang=js"
export * from "./Throughput.vue?vue&type=script&lang=js"
script.render = render

export default script